import React, { Fragment, useState } from 'react'
import { formatDbTime } from '../../../utils/dateFormater'
import DefaultAvatar from "../../images/default_avatar.jpg"
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Link } from 'react-router-dom';

dayjs.extend(relativeTime);


const SingleMessage = ({ message, index, other_user, lastSeenMessageIndex }) => {

    const [isLiked, setIsLiked] = useState(false);
    const handleClassName = (ProductStatus) => {


        if (ProductStatus === "ACTIVE") return "text-green-600 bg-green-100";
        if (ProductStatus === "SYSTEM_CANCELLED") return "text-red-600 bg-red-100";
        if (ProductStatus === "SUSPENDED") return "text-orange-600 bg-orange-100";
        if (ProductStatus === "INACTIVE") return "text-purple-600 bg-purple-100";
        if (ProductStatus === "PAUSED") return "text-orange-600 bg-orange-100";

    }






    const handleClassNameForOrder = (orderStatus) => {


        if (orderStatus === "ORDERED") return "text-green-600 bg-green-100";
        if (orderStatus === "REVIEWED") return "text-pink-500 bg-pink-100";
        if (orderStatus === "DELIVERED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "SUSPENDED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "ON_HOLD") return "text-blue-500 bg-blue-100";
        if (orderStatus === "REFUNDED") return "text-green-600 bg-green-100";
        if (orderStatus === "COMMISSIONED") return "text-slate-500 bg-slate-100";
        if (orderStatus === "COMPLETED") return "text-purple-500 bg-purple-100";
        if (orderStatus === "CANCELLED") return "text-[#B04926] bg-[#b0482637]";
        if (orderStatus === "REVIEW_DELETED") return "text-red-500 bg-red-100";
        if (orderStatus === "SYSTEM_CANCELLED") return "text-red-500 bg-red-100";

    }







    const isSeen =
        other_user?.last_read_at &&
        new Date(message?.created_at) <= new Date(other_user?.last_read_at);



    return (
        <Fragment>
            {message?.message_sender === "other" ? (
                <div className="flex items-start justify-start gap-[1vmax] mb-[2vmax]" >
                    {/* Avatar */}
                    <div className="w-[2.5vmax] h-[2.5vmax] rounded-full overflow-hidden flex-shrink-0 border border-gray-100 shadow-sm">
                        <img src={message?.avatar_url || DefaultAvatar} alt="Avatar" className="w-full h-full object-cover" />
                    </div>

                    {/* Message Bubble */}
                    <div className={`bg-white border border-gray-100 p-[0.8vmax_1.2vmax] rounded-2xl rounded-tl-none shadow-sm text-[0.95vmax] text-gray-800 font-medium relative break-words max-w-[50%] animate-[fadeIn_0.3s_ease-out] ${(message?.related_product_id || message?.related_order_id) && "w-[50%]"}`}>
                        
                        {/* Attached Image */}
                        {message?.image_url && (
                            <div className="mb-[0.5vmax] rounded-lg overflow-hidden border border-gray-100">
                                <img src={message?.image_url} alt="" className='w-full object-cover' />
                            </div>
                        )}

                        {/* Tagged Product */}
                        {message?.related_product_id && (
                            <div className="bg-gray-50 border border-gray-100 p-[0.8vmax] rounded-lg mb-[0.8vmax] relative">
                                <div className="absolute top-[-0.6vmax] right-[0.5vmax] bg-indigo-600 text-white text-[0.65vmax] font-bold px-[0.5vmax] py-[0.1vmax] rounded-full">
                                    Product
                                </div>
                                <div className="flex gap-[0.8vmax] items-center">
                                    <div className="w-[2.5vmax] h-[2.5vmax] rounded-md overflow-hidden bg-white border border-gray-100">
                                        <img src={message?.product?.custom_image} alt="" className='w-full h-full object-cover' />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <div className="text-[0.85vmax] font-bold text-gray-800 truncate">ID: {message?.product?.id}</div>
                                        <span className={`text-[0.7vmax] font-bold px-[0.4vmax] py-[0.1vmax] rounded-full mt-[0.2vmax] inline-block ${handleClassName(message?.product?.status)}`}>
                                            {message?.product?.status?.replaceAll("_", " ").toUpperCase()}
                                        </span>
                                    </div>
                                    <Link to={`/products/single-product?id=${message?.product?.id}`} className='text-indigo-600 text-[0.85vmax] font-bold hover:text-indigo-700'>
                                        View
                                    </Link>
                                </div>
                            </div>
                        )}

                        {/* Tagged Order */}
                        {message?.related_order_id && (
                            <div className="bg-gray-50 border border-gray-100 p-[0.8vmax] rounded-lg mb-[0.8vmax] relative">
                                <div className="absolute top-[-0.6vmax] right-[0.5vmax] bg-emerald-600 text-white text-[0.65vmax] font-bold px-[0.5vmax] py-[0.1vmax] rounded-full">
                                    Order
                                </div>
                                <div className="flex gap-[0.8vmax] items-center">
                                    <div className="w-[2.5vmax] h-[2.5vmax] rounded-md overflow-hidden bg-white border border-gray-100">
                                        <img src={message?.order?.product?.custom_image} alt="" className='w-full h-full object-cover' />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <div className="text-[0.85vmax] font-bold text-gray-800 truncate">ID: {message?.order?.id}</div>
                                        <span className={`text-[0.7vmax] font-bold px-[0.4vmax] py-[0.1vmax] rounded-full mt-[0.2vmax] inline-block ${handleClassNameForOrder(message?.order?.status)}`}>
                                            {message?.order?.status?.replaceAll("_", " ").toUpperCase()}
                                        </span>
                                    </div>
                                    <Link to={`/orders/order-details?order_id=${message?.order?.id}`} className='text-emerald-600 text-[0.85vmax] font-bold hover:text-emerald-700'>
                                        View
                                    </Link>
                                </div>
                            </div>
                        )}

                        {/* Message Text */}
                        <div className="text-[0.95vmax] font-medium leading-relaxed">{message?.message}</div>
                        
                        {/* Timestamp */}
                        <div className="text-[0.7vmax] text-gray-400 mt-[0.3vmax] text-right">
                            {formatDbTime(message?.created_at)}
                        </div>
                    </div>
                </div>
            ) : message?.message_sender === "me" && (
                <div className="flex items-start justify-end gap-[1vmax] mb-[2vmax]" >
                    {/* Message Bubble */}
                    <div 
                        className={`bg-indigo-600 text-white p-[0.8vmax_1.2vmax] rounded-2xl rounded-tr-none shadow-sm text-[0.95vmax] font-medium relative break-words max-w-[50%] cursor-pointer animate-[fadeIn_0.3s_ease-out] ${(message?.related_product_id || message?.related_order_id) && "w-[50%]"}`}
                        onDoubleClick={() => setIsLiked(!isLiked)}
                    >
                        
                        {/* Attached Image */}
                        {message?.image_url && (
                            <div className="mb-[0.5vmax] rounded-lg overflow-hidden border border-indigo-500">
                                <img src={message?.image_url} alt="" className='w-full object-cover' />
                            </div>
                        )}

                        {/* Tagged Product */}
                        {message?.related_product_id && (
                            <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-[0.8vmax] rounded-lg mb-[0.8vmax] relative">
                                <div className="absolute top-[-0.6vmax] right-[0.5vmax] bg-white text-indigo-600 text-[0.65vmax] font-bold px-[0.5vmax] py-[0.1vmax] rounded-full">
                                    Product
                                </div>
                                <div className="flex gap-[0.8vmax] items-center">
                                    <div className="w-[2.5vmax] h-[2.5vmax] rounded-md overflow-hidden bg-white border border-gray-100">
                                        <img src={message?.product?.custom_image} alt="" className='w-full h-full object-cover' />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <div className="text-[0.85vmax] font-bold text-white truncate">ID: {message?.product?.id}</div>
                                        <span className={`text-[0.7vmax] font-bold px-[0.4vmax] py-[0.1vmax] rounded-full mt-[0.2vmax] inline-block ${handleClassName(message?.product?.status)}`}>
                                            {message?.product?.status?.replaceAll("_", " ").toUpperCase()}
                                        </span>
                                    </div>
                                    <Link to={`/products/single-product?id=${message?.product?.id}`} className='text-white text-[0.85vmax] font-bold hover:underline'>
                                        View
                                    </Link>
                                </div>
                            </div>
                        )}

                        {/* Tagged Order */}
                        {message?.related_order_id && (
                            <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-[0.8vmax] rounded-lg mb-[0.8vmax] relative">
                                <div className="absolute top-[-0.6vmax] right-[0.5vmax] bg-white text-emerald-600 text-[0.65vmax] font-bold px-[0.5vmax] py-[0.1vmax] rounded-full">
                                    Order
                                </div>
                                <div className="flex gap-[0.8vmax] items-center">
                                    <div className="w-[2.5vmax] h-[2.5vmax] rounded-md overflow-hidden bg-white border border-gray-100">
                                        <img src={message?.order?.product?.custom_image} alt="" className='w-full h-full object-cover' />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <div className="text-[0.85vmax] font-bold text-white truncate">ID: {message?.order?.id}</div>
                                        <span className={`text-[0.7vmax] font-bold px-[0.4vmax] py-[0.1vmax] rounded-full mt-[0.2vmax] inline-block ${handleClassNameForOrder(message?.order?.status)}`}>
                                            {message?.order?.status?.replaceAll("_", " ").toUpperCase()}
                                        </span>
                                    </div>
                                    <Link to={`/orders/order-details?order_id=${message?.order?.id}`} className='text-white text-[0.85vmax] font-bold hover:underline'>
                                        View
                                    </Link>
                                </div>
                            </div>
                        )}

                        {/* Message Text */}
                        <div className="text-[0.95vmax] font-medium leading-relaxed">{message?.message}</div>
                        
                        {/* Status & Timestamp */}
                        <div className="flex justify-end items-center gap-[0.5vmax] mt-[0.3vmax] text-[0.7vmax] text-indigo-200">
                            <span>{formatDbTime(message?.created_at)}</span>
                            <span className="ml-[0.2vmax]">
                                {!other_user?.last_read_at ? (
                                    <i className="fa-solid fa-check text-indigo-200" title="Sent"></i>
                                ) : isSeen ? (
                                    <i className="fa-solid fa-check-double text-sky-400" title={`Seen ${dayjs(other_user.last_read_at).fromNow()}`}></i>
                                ) : (
                                    <i className="fa-solid fa-check-double text-indigo-200" title="Delivered"></i>
                                )}
                            </span>
                        </div>
                        
                        {/* Like Reaction (Visual Only) */}
                        {isLiked && (
                            <div className="absolute bottom-[-0.5vmax] right-[-0.5vmax] bg-white text-red-500 rounded-full w-[1.2vmax] h-[1.2vmax] flex items-center justify-center shadow-sm text-[0.7vmax]">
                                <i className="fa-solid fa-heart"></i>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </Fragment>
    )
}

export default SingleMessage
